// SurveyModal.js
import React, { useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { publicVapidKey, serverURL } from '../constants';
import { toast } from 'react-toastify';
import { messaging } from '../firebase';
import { getToken } from 'firebase/messaging';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from "@react-icons/all-files/fa/FaPlus";
import { websiteURL, logo, company } from '../constants';
import FileUploadSection from '../components/FileUploadSection';
import StudyTimePreference from '../components/StudyTimePreference';
import RestDaysPreference from '../components/RestDaysPreference';
axios.defaults.withCredentials = true;

const ListEntry = styled.div`
  margin-bottom: 15px;
  border: 1px solid #ccc;
  padding: 15px;
  border-radius: 5px;
`;


const AddButton = styled.button`
  background: none;
  border: none;
  color: #135D66;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 14px;
`;

const IconWrapper = styled.span`
  margin-right: 5px;
  display: flex;
  align-items: center;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;
const CheckboxGroup = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 10px;
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  cursor: pointer;
`;

const Checkbox = styled.input`
  margin-right: 10px;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: -32px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
`;
const showToast = async (msg) => {
    toast(msg, {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined
    });
}
const ModalContent = styled.div`
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  width: 80%;
  max-width: 500px;
  max-height: 80%;
  display: flex;
  flex-direction: column;
`;

const CloseButton = styled.button`
  align-self: flex-end;
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
`;

const FormGroup = styled.div`
  margin-bottom: 15px;
`;

const Input = styled.input`
  width: 100%;
  padding: 10px;
  font-size: 16px;
`;

const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  font-size: 16px;
`;

const Button = styled.button`

`;

const SurveyModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [step, setStep] = useState(0);
    const [responses, setResponses] = useState({});
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const navigate = useNavigate();
    const [examDetails, setExamDetails] = useState([{
        subject: '',
        date: '',
        assignmentFileText: '',
        fileName: '' // Add this to track file name
    }]);

    const [projectDetails, setProjectDetails] = useState([{
        subject: '',
        description: '',
        deadline: '',
        assignmentFileText: '',
        fileName: '' // Add this to track file name
    }]);


    const [notificationMethods, setNotificationMethods] = useState([]);
    const [submitBtnText, setSubmitBtnText] = useState("Submit");

    // Define questions with only required ones marked as mandatory
    const questions = [
        { type: 'text', question: 'Grade Level / Year of Study:', key: 'grade', required: true },
        { type: 'text', question: 'Major / Field of Study:', key: 'major', required: false },
        { type: 'multiple-choice', question: 'How many hours do you typically study each day?', key: 'studyHours', options: ['Less than 1 hour', '1-2 hours', '2-4 hours', 'More than 4 hours'], required: true },
        {
            type: 'time-preference',
            question: 'What time of day do you prefer to study?',
            key: 'studyTime',
            required: true
        },
        {
            type: 'rest-days',
            question: 'When would you prefer to rest from studying?',
            key: 'restDays',
            required: true
        },
        { type: 'multiple-choice', question: 'Do you study better with breaks, or in long, uninterrupted sessions?', key: 'studyMethodOfBreaks', options: ['With breaks', 'Uninterrupted sessions'], required: false },
        { type: 'text', question: 'Do you have any upcoming exams?  If yes, please list the subjects and dates of your upcoming exams.', key: 'examDetails', required: false },
        { type: 'text', question: 'Do you have any upcoming projects or assignments? If yes, please list the subjects, descriptions, and deadlines of your upcoming projects or assignments.', key: 'projectDetails', required: false },
        { type: 'text', question: 'Which subjects do you find most challenging?', key: 'challengingSubjects', required: false },
        { type: 'text', question: 'Do you have any specific topics or areas you want to focus on?', key: 'focusAreas', required: false },
        { type: 'multiple-choice', question: 'Would you like to receive subject-specific quizzes to reinforce your knowledge?', key: 'quizzes', options: ['Yes', 'No'], required: false },
        { type: 'multiple-choice', question: 'Would you like the AI to allocate specific times for essay writing tasks (research, drafting, revising)?', key: 'essayTasks', options: ['Yes', 'No'], required: false },
        { type: 'multiple-choice', question: 'Do you currently use Google Calendar?', key: 'usesGoogleCalendar', options: ['Yes', 'No'], required: true },
        { type: 'multiple-choice', question: 'Would you like the AI planning feature to integrate with your Google Calendar?', key: 'calendarIntegration', options: ['Yes', 'No'], required: true },
        { type: 'multiple-choice', question: 'How would you like to receive reminders and notifications?', key: 'notificationMethod', options: ['Email', 'SMS', 'Mobile App Notification'], required: false },
        { type: 'multiple-choice', question: 'Would you like to receive feedback sessions with assistants for your essays?', key: 'feedbackSessions', options: ['Yes', 'No'], required: false },
        // { type: 'multiple-choice', question: 'Would you be interested in a feature that adjusts your study plan based on quiz performance?', key: 'adjustStudyPlan', options: ['Yes', 'No'], required: false },
        { type: 'text', question: 'Do you have any additional comments or suggestions to improve the AI planning feature?', key: 'comments', required: false }
    ];
    const openModal = async () => {
        const user_id = localStorage.getItem('uid')
        const hasFutureEvents = await checkFutureEvents(user_id);
        if (hasFutureEvents) {
            showToast("You already have an active schedule , Please delete it first and try again");
            return;
        }
        const notificationsAllowed = await requestNotificationPermission();
        if (!notificationsAllowed) {
            return;
        }
        if (!isPopupBlocked()) {

            return;
        }
        setIsOpen(true)
    }
    async function sendEmail() {
        try {
            const mEmail = localStorage.getItem('email');
            const dataToSend = {
                subject: `Timetable Generated`,
                to: mEmail,
                html: `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
                <meta http-equiv="Content-Type" content="text/html charset=UTF-8" />
                <html lang="en">
                
                  <head></head>
                 <div id="__react-email-preview" style="display:none;overflow:hidden;line-height:1px;opacity:0;max-height:0;max-width:0">New timetable created<div> ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿ ‌​‍‎‏﻿</div>
                 </div>
                
                  <body style="margin-left:auto;margin-right:auto;margin-top:auto;margin-bottom:auto;background-color:rgb(255,255,255);font-family:ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, &quot;Segoe UI&quot;, Roboto, &quot;Helvetica Neue&quot;, Arial, &quot;Noto Sans&quot;, sans-serif, &quot;Apple Color Emoji&quot;, &quot;Segoe UI Emoji&quot;, &quot;Segoe UI Symbol&quot;, &quot;Noto Color Emoji&quot;">
                    <table align="center" role="presentation" cellSpacing="0" cellPadding="0" border="0" width="100%" style="max-width:37.5em;margin-left:auto;margin-right:auto;margin-top:40px;margin-bottom:40px;width:465px;border-radius:0.25rem;border-width:1px;border-style:solid;border-color:rgb(234,234,234);padding:20px">
                      <tr style="width:100%">
                        <td>
                          <table align="center" border="0" cellPadding="0" cellSpacing="0" role="presentation" width="100%" style="margin-top:32px">
                            <tbody>
                              <tr>
                                <td><img alt="Vercel" src="${logo}" width="40" height="37" style="display:block;outline:none;border:none;text-decoration:none;margin-left:auto;margin-right:auto;margin-top:0px;margin-bottom:0px" /></td>
                              </tr>
                            </tbody>
                          </table>
                          <h1 style="margin-left:0px;margin-right:0px;margin-top:30px;margin-bottom:30px;padding:0px;text-align:center;font-size:24px;font-weight:400;color:rgb(0,0,0)">Timetable Upgraded</h1>
                          <p style="font-size:14px;line-height:24px;margin:16px 0;color:rgb(0,0,0)">We have created a personalized timetable for you to study better , Please click on calendar button below to explore. Happy Learning!</p>
                          <table align="center" border="0" cellPadding="0" cellSpacing="0" role="presentation" width="100%" style="margin-bottom:32px;margin-top:32px;text-align:center">
                            <tbody>
                              <tr>
                                <td><a href="${websiteURL}/calendar" target="_blank" style="p-x:20px;p-y:12px;line-height:100%;text-decoration:none;display:inline-block;max-width:100%;padding:12px 20px;border-radius:0.25rem;background-color:rgb(0,0,0);text-align:center;font-size:12px;font-weight:600;color:rgb(255,255,255);text-decoration-line:none"><span></span><span style="p-x:20px;p-y:12px;max-width:100%;display:inline-block;line-height:120%;text-decoration:none;text-transform:none;mso-padding-alt:0px;mso-text-raise:9px"</span><span>View Calendar</span></a></td>
                              </tr>
                            </tbody>
                          </table>
                          <p style="font-size:14px;line-height:24px;margin:16px 0;color:rgb(0,0,0)">Best,<p target="_blank" style="color:rgb(0,0,0);text-decoration:none;text-decoration-line:none">The <strong>${company}</strong> Team</p></p>
                          </td>
                      </tr>
                    </table>
                  </body>
                
                </html>`
            };
            console.log(dataToSend.html);

            const postURL = serverURL + '/api/data';
            await axios.post(postURL, dataToSend).then(res => {
            }).catch(error => {
            });

        } catch (error) {
        }

    }
    const requestNotificationPermission = async () => {

        try {
            if (!('Notification' in window) || !('serviceWorker' in navigator) || !('PushManager' in window)) {

                showToast('Push notifications are not supported in this browser.');
                return false;
            }

            // Ask for user notification permission
            const permission = await Notification.requestPermission();

            if (permission !== 'granted') {

                showToast('Please allow browser notifications to continue');
                return false;
            }

            const token = await getToken(messaging, { vapidKey: publicVapidKey });

            if (token) {
                const user_id = localStorage.getItem('uid'); // Get user ID from session storage

                await axios.post(serverURL + '/api/saveSubscription', { token, user_id });
                return true;
            }

            return false;
        } catch (err) {

            showToast('Please allow browser notifications to continue');

            return false;
        }
    };

    // Function to check if popups are blocked
    const isPopupBlocked = () => {
        let popup = null;
        try {
            // Try opening a small popup window
            popup = window.open('', '', 'width=100,height=100');

            if (!popup || popup.closed || typeof popup.closed === 'undefined') {
                showToast('Please allow popups to continue');
                return false;
            }

            popup.close();
            return true;
        } catch (err) {
            showToast('Please allow popups to continue');

            return false;
        }
    };
    const handleInputChange = (e) => {
        setResponses({ ...responses, [questions[step].key]: e.target.value });
    };

    const handleOptionChange = (e) => {
        setResponses({ ...responses, [questions[step].key]: e.target.value });
    };

    const handleNext = () => {
        const currentQuestion = questions[step];

        // Check if the current question is required and if it has a response
        if (currentQuestion.required && !responses[currentQuestion.key]) {
            setErrorMessage('This question is required.');
            return;
        }

        if (step < questions.length - 1) {
            setErrorMessage('');
            setStep(step + 1);
        } else {
            submitResponses();
        }
    };
    const handleExamDetailsChange = (index, field, value, fileName = '') => {
        const updatedDetails = [...examDetails];
        updatedDetails[index][field] = value;
        if (field === 'assignmentFileText') {
            updatedDetails[index].fileName = fileName;
        }
        setExamDetails(updatedDetails);
        setResponses({ ...responses, examDetails: updatedDetails });
    };

    const handleProjectDetailsChange = (index, field, value, fileName = '') => {
        const updatedDetails = [...projectDetails];
        updatedDetails[index][field] = value;
        if (field === 'assignmentFileText') {
            updatedDetails[index].fileName = fileName;
        }
        setProjectDetails(updatedDetails);
        setResponses({ ...responses, projectDetails: updatedDetails });
    };

    const addProjectEntry = () => {
        setProjectDetails([...projectDetails, {
            subject: '',
            description: '',
            deadline: '',
            assignmentFileText: '',
            fileName: ''
        }]);
    };

    const addExamEntry = () => {
        setExamDetails([...examDetails, {
            subject: '',
            date: '',
            assignmentFileText: '',
            fileName: ''
        }]);
    };
    const handleNotificationMethodChange = (method) => {
        setNotificationMethods(prevMethods => {
            if (prevMethods.includes(method)) {
                return prevMethods.filter(m => m !== method);
            } else {
                return [...prevMethods, method];
            }
        });
    };

    async function createStudyPlan(responses) {
        const userId = localStorage.getItem('uid'); // Get user ID from session storage
        try {

            const response = await axios.post(`${serverURL}/api/create-study-plan`, { responses, userId });
            return true;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                // Open auth window
                const authWindow = window.open(
                    `${serverURL}/api/auth?userId=${encodeURIComponent(userId)}`,
                    'Auth',
                    'width=500,height=600'
                );
                if (!authWindow) {
                    showToast("Please Allow popup and try again");

                    return false;
                }

                // Poll to check if the auth window has closed
                const pollTimer = window.setInterval(() => {
                    if (authWindow.closed) {
                        window.clearInterval(pollTimer);
                        // Retry creating the study plan
                        createStudyPlan(responses);
                    }
                }, 500);
            } else {
                console.error('Error creating study plan:', error);
                return false;
            }
        }
    }
    async function deleteStudyPlan() {
        const userId = localStorage.getItem('uid'); // Get user ID from session storage
        try {

            const response = await axios.post(`${serverURL}/api/delete-quiz`, { userId });
            return true;
        } catch (error) {
            if (error.response && error.response.status === 401) {
                // Open auth window
                const authWindow = window.open(
                    `${serverURL}/api/auth?userId=${encodeURIComponent(userId)}`,
                    'Auth',
                    'width=500,height=600'
                );
                if (!authWindow) {
                    showToast("Please Allow popup and try again");

                    return false;
                }

                // Poll to check if the auth window has closed
                const pollTimer = window.setInterval(() => {
                    if (authWindow.closed) {
                        window.clearInterval(pollTimer);
                        // Retry creating the study plan
                        deleteStudyPlan();
                    }
                }, 500);
            } else {
                console.error('Error creating study plan:', error);
            }
        }
    }

    const checkFutureEvents = async (userId) => {
        try {
            const response = await fetch(serverURL + `/api/future-events/${userId}`);
            const data = await response.json();

            // Return true if record is 1 (future events exist), otherwise return false
            return data.record === 1;
        } catch (error) {
            console.error('Error fetching future events:', error);
            return false; // In case of an error, we return false
        }
    };
    const submitResponses = async () => {
        // setSubmitBtnText("Please wait...");
        const userId = localStorage.getItem('uid'); // Get user ID from session storag


        if (isSubmitting) {
            // return;
        }
        if (!userId) {
            setIsSubmitting(false);
            setSubmitBtnText("Submit");
            showToast("Please Login to use this feature");
            return; // Exit if there's no user ID
        }
        const hasFutureEvents = await checkFutureEvents(userId);
        if (hasFutureEvents) {
            showToast("You already have an active schedule , Please delete it first and try again");
            setIsSubmitting(false);

            setSubmitBtnText("Submit");
            return;
        }
        setIsSubmitting(true);

        const toastId = toast.loading("Please wait...")


        setResponses({ ...responses, ['userId']: userId });

        const formattedResponses = {
            userId: userId,
            name: responses.name,
            email: responses.email,
            gradeLevel: responses.grade,
            major: responses.major,
            studyHours: responses.studyHours,
            studyTime: responses.studyTime,
            studyStyle: responses.studyMethodOfBreaks,
            restDays: responses.restDays,
            upcomingExams: {
                hasExams: examDetails.length > 0,
                exams: examDetails
            },
            upcomingProjects: {
                hasProjects: projectDetails.length > 0,
                projects: projectDetails
            },
            challengingSubjects: responses.challengingSubjects ? responses.challengingSubjects.split(',').map(s => s.trim()) : [],
            focusTopics: responses.focusAreas ? responses.focusAreas.split(',').map(s => s.trim()) : [],
            quizzes: responses.quizzes,
            essayTasks: responses.essayTasks,
            calendarIntegration: responses.calendarIntegration,
            notifications: {
                method: notificationMethods
            },
            feedbackSessions: responses.feedbackSessions,
            quizPerformanceAdjustment: responses.adjustStudyPlan === 'Yes',
            additionalComments: responses.comments
        };

        // console.log(formattedResponses);
        // return;

        // Send survey responses to the backend
        await axios.post(serverURL + '/api/survey', formattedResponses);
        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];
        // Create a new Date object for one month later to avoid modifying the original date
        const oneMonthAfter = new Date();
        oneMonthAfter.setMonth(today.getMonth() + 1);

        const formattedOneMonth = oneMonthAfter.toISOString().split('T')[0];
        const prompt = `
Objective: Create a personalized, dynamic month-long study plan tailored to the user's survey responses and any uploaded handwritten descriptions or documents. The plan should account for overlapping details between user-provided descriptions and uploaded files, ensuring a cohesive and comprehensive approach.

1. If overlaps exist between handwritten descriptions (e.g., topics like "Baroque Era" or "Medieval Era") and the content in uploaded documents, the AI should:
   - Merge overlapping descriptions to create a unified study task.
   - Prioritize both sources equally while ensuring no duplication.

2. If there are no overlaps, the AI must:
   - Focus independently on the handwritten descriptions and the uploaded content, dividing attention proportionally.

3. The AI must integrate Google Calendar for the plan, generating a JSON response with the following structure:


{
    "name": "",
    "email": "",
    "studyPlan": [
        {
            "start_date": "yyyy-mm-dd",
            "start_time": "hh:mm",
            "end_date": "yyyy-mm-dd",
            "end_time": "hh:mm",
            "duration": "",
            "subject": "",
            "studyTime": "",
            "task": "",
            "calendarIntegration": ${responses.calendarIntegration}
        }
    ]
}

4. General Guidelines:
   -   - The plan starts from  ${formattedDate} to ${formattedOneMonth}.

   - Allocate multiple events per day.
   -Add breaks between tasks if the "studyMethodOfBreaks" is set to "With breaks."
   - Account for essay writing tasks if "essayTasks" is "Yes."
   - Align study times with the user's preferred time of day from the survey.
   - Include specific dates and times for exams, projects, and assignments provided in the survey.
   - Focus areas (e.g., challenging subjects or specific topics) should receive prioritized attention.

5. Assignment File Handling:
   - If assignmentFileText is not null, ensure the content is utilized alongside the survey responses.
   - The AI should process the file content in string format and integrate it seamlessly with the plan.

6. Survey Responses Integration:
   - Base the plan on the formattedResponses object, ensuring fields like studyHours, studyTime, challengingSubjects, and focusTopics are well-represented.
   - Tailor the schedule to fit the user's preferences for breaks, quizzes, and essay writing.

7. Key Constraints:
   - Ensure all study sessions end on the same day they start.
   - Avoid adding extra characters or formatting outside the JSON structure.
8. Strictly do not add any events on weekends. 
9.Pay attention to the year of date from ${formattedDate} after 31 dec new year starts.
10. Rest Days:
   - strictly avoid Specified rest days: ${formattedResponses.restDays.selectedDays.join(', ')}
   - Strictly Do not schedule any study sessions on any : ${formattedResponses.restDays.selectedDays.join(', ')}

Today's date is ${formattedDate}. Use the user's survey responses and integrate Google Calendar. Please return the JSON response without any formatting or code blocks. Here is the user's survey response: ${JSON.stringify(formattedResponses)}`;



        const postURL = serverURL + '/api/gpt-prompt';
        const dataToSend = { prompt: prompt }; // Adjust the data structure according to your API requirements

        // Send the prompt to the backend to generate the study plan
        const res = await axios.post(postURL, dataToSend);
        if (res.status !== 200) {
            toast.update(toastId, { render: "Something went wrong , Please try again later.", type: "error", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
            setIsSubmitting(false);
            setLoading(false);
            setIsOpen(true);
            setSubmitBtnText("Submit");
            return;
        }
        const generatedText = res.data.generatedText;
        const deletePlan = await deleteStudyPlan();
        // Save the generated text along with the user ID
        const saveData = { userId: userId, generatedText: generatedText };

        setIsSubmitting(false);

        // Optionally handle successful save operation
        let studyPlan = await createStudyPlan(JSON.parse(generatedText));
        await sendEmail();

        if (studyPlan) {
            setLoading(false); // Stop loading indicator
            setIsSubmitting(false);
            toast.update(toastId, { render: "Study Plan is created successfully", type: "success", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
            setTimeout(() => {
                navigate("/calendar");
            }, 3000);
        } else {
            toast.update(toastId, { render: "Something went wrong , Please try again later.", type: "error", isLoading: false, autoClose: 3000, hideProgressBar: false, closeOnClick: true });
            setIsSubmitting(false);
            setLoading(false);
            setIsOpen(true);
            setSubmitBtnText("Submit");
            return;
        }
    };
    const handleBack = () => {
        if (step > 0) {
            setStep(step - 1);
            setErrorMessage('');
        }
    };

    const renderQuestion = () => {
        const question = questions[step];
        switch (question.type) {
            case 'text':
                if (question.key === 'examDetails') {
                    return (
                        <FormGroup>
                            {examDetails.map((exam, index) => (
                                <ListEntry key={index}>
                                    <Input
                                        type="text"
                                        value={exam.subject}
                                        onChange={(e) => handleExamDetailsChange(index, 'subject', e.target.value)}
                                        placeholder="Subject"
                                    />
                                    <TextArea
                                        placeholder="Description" className='mt-3'
                                    />
                                    <Label className='mt-3' htmlFor={`exam-date-${index}`}>Exam Date</Label>

                                    <Input
                                        type="date"
                                        value={exam.date}
                                        onChange={(e) => handleExamDetailsChange(index, 'date', e.target.value)}
                                    />
                                    <FileUploadSection
                                        key={`exam-${index}`}  // Add unique key
                                        onTextExtracted={(text, fileName) =>
                                            handleExamDetailsChange(index, 'assignmentFileText', text, fileName)
                                        }
                                        onRemove={() =>
                                            handleExamDetailsChange(index, 'assignmentFileText', '', '')
                                        }
                                        fileName={exam.fileName}  // Pass current file name
                                    />
                                </ListEntry>
                            ))}
                            <AddButton onClick={addExamEntry}>
                                <IconWrapper>
                                    <FaPlus size={14} />
                                </IconWrapper>
                                Add another exam
                            </AddButton>
                        </FormGroup>
                    );
                }
                if (question.key === 'projectDetails') {
                    return (
                        <FormGroup>
                            {projectDetails.map((project, index) => (
                                <ListEntry key={index}>
                                    <Input
                                        type="text"
                                        value={project.subject}
                                        onChange={(e) => handleProjectDetailsChange(index, 'subject', e.target.value)}
                                        placeholder="Subject"
                                    />
                                    <TextArea
                                        value={project.description}
                                        onChange={(e) => handleProjectDetailsChange(index, 'description', e.target.value)}
                                        className='mt-3'
                                        placeholder="Description"
                                    />
                                    <Label className='mt-3' htmlFor={`project-deadline-${index}`}>Deadline</Label>

                                    <Input
                                        type="date"
                                        value={project.deadline}
                                        onChange={(e) => handleProjectDetailsChange(index, 'deadline', e.target.value)}
                                    />
                                    <FileUploadSection
                                        key={`project-${index}`}  // Add unique key
                                        onTextExtracted={(text, fileName) =>
                                            handleProjectDetailsChange(index, 'assignmentFileText', text, fileName)
                                        }
                                        onRemove={() =>
                                            handleProjectDetailsChange(index, 'assignmentFileText', '', '')
                                        }
                                        fileName={project.fileName}  // Pass current file name
                                    />
                                </ListEntry>
                            ))}
                            <AddButton onClick={addProjectEntry}>
                                <IconWrapper>
                                    <FaPlus size={14} />
                                </IconWrapper>
                                Add another project/assignment
                            </AddButton>
                        </FormGroup>
                    );
                }
                return (
                    <FormGroup>
                        <Input
                            type="text"
                            value={responses[question.key] || ''}
                            onChange={handleInputChange}
                            placeholder={question.question}
                        />
                    </FormGroup>
                );
            case 'textarea':
                return (
                    <FormGroup>
                        <TextArea
                            value={responses[question.key] || ''}
                            onChange={handleInputChange}
                            placeholder={question.question}
                        />
                    </FormGroup>
                );
            case 'multiple-choice':
                if (question.key === 'notificationMethod' || question.key === 'studyTime') {
                    return (
                        <FormGroup>
                            {/* <Label>{question.question}</Label> */}
                            <CheckboxGroup>
                                {question.options.map((option) => (
                                    <CheckboxLabel key={option}>
                                        <Checkbox
                                            type="checkbox"
                                            checked={notificationMethods.includes(option)}
                                            onChange={() => handleNotificationMethodChange(option)}
                                        />
                                        {option}
                                    </CheckboxLabel>
                                ))}
                            </CheckboxGroup>
                        </FormGroup>
                    );
                }
                return (
                    <FormGroup>
                        {question.options.map(option => (
                            <div className='my-2' >

                                <label key={option}>
                                    <input
                                        type="radio"
                                        name={question.key}
                                        value={option}
                                        className='mx-2'
                                        checked={responses[question.key] === option}
                                        onChange={handleOptionChange}
                                    />
                                    {option}
                                </label>
                            </div>
                        ))}
                    </FormGroup>
                );
            case 'yes-no':
                return (
                    <FormGroup>
                        <label>
                            <input
                                type="radio"
                                name={question.key}
                                value="Yes"
                                checked={responses[question.key] === 'Yes'}
                                onChange={handleOptionChange}
                            />
                            Yes
                        </label>
                        <label>
                            <input
                                type="radio"
                                name={question.key}
                                value="No"
                                checked={responses[question.key] === 'No'}
                                onChange={handleOptionChange}
                            />
                            No
                        </label>
                    </FormGroup>
                );
            case 'time-preference':
                return (
                    <FormGroup>
                        <StudyTimePreference
                            onPreferenceChange={(preference) => {
                                setResponses({ ...responses, [question.key]: preference });
                            }}
                        />
                    </FormGroup>
                );
            case 'rest-days':
                return (
                    <FormGroup>
                        <RestDaysPreference
                            onPreferenceChange={(preference) => {
                                setResponses({ ...responses, [question.key]: preference });
                            }}
                        />
                    </FormGroup>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <Button className='border-b-0 text-white  font-normal mb-2 mt-2 bg-black dark:text-black dark:bg-white  hover:bg-black dark:hover:bg-white md:dark:hover:bg-white md:hover:bg-black hover:text-white md:hover:text-white dark:hover:text-black dark:md:hover:text-black' style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px', paddingTop: '10px' }} onClick={openModal}>Create Study Plan</Button>
            {isOpen && (
                <ModalOverlay>
                    <ModalContent style={{ overflowY: 'scroll' }} >
                        <CloseButton onClick={() => setIsOpen(false)}>&times;</CloseButton>
                        <div className="mb-2">
                            <h1>{questions[step].question}</h1>
                        </div>
                        {renderQuestion()}
                        {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
                        <ButtonContainer>
                            {step > 0 && (
                                <Button
                                    className='border-b-0 text-white font-normal mb-2 mt-2 bg-black dark:text-black dark:bg-white hover:bg-black dark:hover:bg-white md:dark:hover:bg-white md:hover:bg-black hover:text-white md:hover:text-white dark:hover:text-black dark:md:hover:text-black'
                                    style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px', paddingTop: '10px' }}
                                    onClick={handleBack}
                                >
                                    Back
                                </Button>
                            )}
                            {step < questions.length - 1 ? (
                                // "Next" Button
                                <Button
                                    className='border-b-0 text-white font-normal mb-2 mt-2 bg-black dark:text-black dark:bg-white hover:bg-black dark:hover:bg-white md:dark:hover:bg-white md:hover:bg-black hover:text-white md:hover:text-white dark:hover:text-black dark:md:hover:text-black'
                                    style={{ paddingLeft: '15px', paddingRight: '15px', paddingBottom: '10px', paddingTop: '10px' }}
                                    onClick={handleNext}
                                    disabled={loading}
                                >
                                    Next
                                </Button>
                            ) : (
                                // "Submit" Button
                                <Button
                                    className='border-b-0 text-white font-normal mb-2 mt-2 bg-black dark:text-black dark:bg-white hover:bg-black dark:hover:bg-white md:dark:hover:bg-white md:hover:bg-black hover:text-white md:hover:text-white dark:hover:text-black dark:md:hover:text-black'
                                    style={{ paddingLeft: '20px', paddingRight: '20px', paddingBottom: '12px', paddingTop: '12px' }}
                                    onClick={handleNext}
                                    disabled={loading}
                                >
                                    {submitBtnText}
                                </Button>
                            )}

                        </ButtonContainer>
                    </ModalContent>
                </ModalOverlay>
            )}
        </>
    );
};

export default SurveyModal;
